import React, { PureComponent } from 'react';
import Switch from '../standardAttributes/Swatches';
import { updateColor } from '../../../helper/scene';

export default class ColorLaminate extends PureComponent {
  onChange = ({ value }) => ev => {
    const {
      claraApi,
      actions,
      attributeName,
      configuration,
      getAppState,
      setAppState,
    } = this.props;
    if (configuration[attributeName].value === value) return;

    let newAppState = getAppState();

    newAppState = actions.setConfiguration(
      { attribute: attributeName, value: { value } },
      newAppState
    );
    updateColor(claraApi, 'Laminate', value);
    setAppState(newAppState);
  };
  render() {
    return <Switch {...this.props} onChange={this.onChange} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/Attributes/nonStandardAttributes/ColorLaminate.js